import LoaderDicom from "./dicom.js";

const Loader = {
  LoaderDicom
};

export default Loader;
